module.exports = __webpack_public_path__ + "static/media/delete.2b3f6aa2.svg";